import React, { createContext, useContext, useState, ReactNode } from 'react';
import { TTab } from '../../utils';

interface TabsContextType {
    activeTab: TTab;
    setActiveTab: (tab: TTab) => void;
}

const TabsContext = createContext<TabsContextType | undefined>(undefined);

interface TabsProviderProps {
    children: ReactNode;
}

export const TabsProvider: React.FC<TabsProviderProps> = ({ children }) => {
    const [activeTab, setActiveTab] = useState<TTab>('appearance');

    return (
        <TabsContext.Provider value={{ activeTab, setActiveTab }}>
            {children}
        </TabsContext.Provider>
    );
};

export const useTabs = (): TabsContextType => {
    const context = useContext(TabsContext);
    if (!context) {
        throw new Error('useTabs must be used within a TabsProvider');
    }
    return context;
};